<template>
  <div class="router-wrapper">
    <div class="element-wrapper">
      <div v-if="isLoadingData" class="element-info-with-icon">
        <div class="content-box">
          <div class="element-info-icon">
            <div class="os-icon os-icon-grid-18 element-info-rotate"></div>
          </div>
          <div class="element-info-text">
            <h5 class="element-inner-header">{{ $t("general.loading_data") }}</h5>
            <div class="element-inner-desc">
              {{ $t("general.please_wait_data_from_cedoon") }}
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="loadingCompleted && error" class="element-info-with-icon">
        <div class="content-box">
          <div class="element-info-icon">
            <div class="os-icon os-icon-close"></div>
          </div>
          <div class="element-info-text">
            <h5 class="element-inner-header">{{ $t("general.in_progress") }}</h5>
            <div class="element-inner-desc">
              {{ $t("general.error.loading_data") }}
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="os-tabs-w">
          <div class="os-tabs-controls os-tabs-complex">
            <div class="nav-item">
              <h1>{{ $t("reports_search.heading") }}</h1>
            </div>
          </div>
        </div>

        <div class="content-box">
          <div>
            <reports-search
              :screwTypes="screwTypes"
              :templates="templates"
              :searchCriteria="searchCriteria"
              @search="parameter => this.onSearch(parameter)"
              @t="$t"
            ></reports-search>
          </div>

          <div v-if="didSearch || isSearching">
            <reports-search-list
              :reports="reports"
              @getReportExport="getReportExport"
              :USER_ROLE="this.USER_ROLE"
              :didSearch="didSearch"
              :isSearching="isSearching"
              :canExport="this.USER_ROLE === 'admin'"
              @t="$t"
              @showExternalReport="showExternalReport"
              :printPdfDownloadKey="printPdfDownloadKey"
            ></reports-search-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ReportsSearchReact from "@/components/react/components/reports-search";
import ReportsSearchList from "@/components/react/components/reports-search-list";
import moment from "moment";
import fileDownload from "js-file-download";
import * as blobUtil from "blob-util";
import { ReactInVue } from "vuera";
import { graphqlClient } from "@/utils/graphql";
import { REPORT_PRINT_PDF_QUERY } from "@/models/queries/ReportPrintPDFQuery";
import { CharacteristicLanguage, PdfLayout } from "@/models/graphql-global-types";

export default {
  name: "ReportsSearch",
  data() {
    return {
      isLoadingData: true,
      reports: [],
      loadingCompleted: false,
      screwTypes: [],
      templates: [],
      error: false,
      didSearch: false,
      isSearching: false,
      exportError: null,
      isDownloading: false,
      USER_ROLE: "",
      searchCriteria: null,
      printPdfDownloadKey: ""
    };
  },
  components: {
    "reports-search": ReactInVue(ReportsSearchReact),
    "reports-search-list": ReactInVue(ReportsSearchList)
  },
  mounted() {
    this.isLoadingData = true;
    this.USER_ROLE = JSON.parse(sessionStorage.getItem("cedoon_user")).role;

    Promise.all([this.infoSearch("SCREW_TYPE"), this.fetchTemplateNames(), this.fetchSearchCriteria()])
      .then(([infoSearch, fetchTemplateNames, fetchSearchCriteria]) => {
        this.screwTypes = infoSearch.data.productInfoSearch.values.map(v => {
          return {
            value: v.id,
            label: v.name
          };
        });

        this.templates = fetchTemplateNames.data.templates.map(t => {
          return {
            value: t.id,
            label: t.name
          };
        });

        const searchCriteria = fetchSearchCriteria.data.reportSearchCriteria;
        this.searchCriteria = {
          ...searchCriteria,
          from: new Date(searchCriteria.from),
          to: new Date(searchCriteria.to),
          diameterValues: searchCriteria.diameterValues.map((v, index) => {
            return {
              value: v,
              label: v
            };
          }),
          lengthValues: searchCriteria.lengthValues.map((v, index) => {
            return {
              value: v,
              label: v
            };
          })
        };

        this.isLoadingData = false;
        this.loadingCompleted = true;
      })
      .catch(e => {
        console.log(e);
        this.isLoadingData = false;
        this.loadingCompleted = true;
        this.error = true;
      });
  },
  methods: {
    ...mapActions("reportStore", ["fetchSearch", "getReportExport", "fetchSearchCriteria"]),
    ...mapActions("productStore", ["infoSearch"]),
    ...mapActions("templateStore", ["fetchTemplateNames"]),

    onSearch(paraemter) {
      this.isSearching = true;
      this.fetchSearch(paraemter)
        .then(response => {
          this.reports = response.data.searchReports;
          this.didSearch = true;
          this.isSearching = false;
        })
        .catch(e => {
          this.isSearching = false;
        });
    },
    showExternalReport(reportId, sheetIds) {
      console.log("reports/show/" + reportId);
      this.$router.push("/reports/show/" + reportId);
    }
  }
};
</script>

<style scoped></style>
